module.exports = __webpack_public_path__ + "img/b1 (3).5aff0fd6.png";